module.exports = __webpack_public_path__ + "img/SUTD-Productions-Logo.4c555b6a.png";